import { useShopwareContext } from "@shopware/composables";


export const useProductPageCustomData = () => {
  const { apiClient } = useShopwareContext();
  const bekanntData = useState("bekanntData", () => null);
  const ratingData = useState("ratingData", () => null);
  const personalAdviceData = useState("personalAdviceData", () => null);
  const isFetchedProductCustomSettings = useState("isFetchedProductCustomSettings", () => false);
  
  const getProductCustomSettings = async () => {
    if (isFetchedProductCustomSettings.value) {
        return;
    }
    try {
      const response = await apiClient.invoke(
        "productCustomSetting get /get-custom-settings",
        { pathParams: {} }
      );

      if (response?.status === 200) {
        bekanntData.value = response.data?.data.bekannt[0];
        ratingData.value = response.data?.data.rating[0];
        personalAdviceData.value = response.data?.data.personal_advice[0];
        isFetchedProductCustomSettings.value = true;

        return response.data.data;
      } 


    } catch (error) {
      console.error("Error while adding product to last-seen:", error);
    }
  };

  return {
    getProductCustomSettings,
    bekanntData: computed(() => bekanntData.value),
    ratingData: computed(() => ratingData.value),
    personalAdviceData: computed(() => personalAdviceData.value),
    isFetchedProductCustomSettings: computed(() => isFetchedProductCustomSettings.value)
  };
}